import { useEffect, useState } from "react";
import axios from "axios";
import { axiosApi } from "../../utils/axiosApi";

export const useProjectList = (projectId, empId) => {
    const [projectOptions, setProjectOptions] = useState([]);
    const [allProjects, setAllProjects] = useState([]);
    const [departmentOptions, setDepartmentOptions] = useState([]);

    // for all project list
    useEffect(() => {
        // if (!empId) return;
        const fetchAllProjects = async () => {
            const res = await axiosApi(
                process.env.REACT_APP_BASE_URL + "/project/viewproject",
                { empId: empId }
            );

            const projectData = res?.data?.data || [];

            setAllProjects(projectData);

            const finalProjects = projectData.map((item) => ({
                label: item.projName,
                value: item.projectId
            }));

            // Always add Other option
            const formatted = [
                ...finalProjects,
                {
                    label: "Other",
                    value: "other"
                }
            ];

            setProjectOptions(formatted);
        };

        fetchAllProjects();
    }, [empId]);

    // for depattment
    useEffect(() => {

        if (!projectId || projectId === "other") {
            setDepartmentOptions([]);
            return;
        }

        const fetchProjectById = async () => {
            try {
                const res = await axiosApi(
                    process.env.REACT_APP_BASE_URL + "/project/viewproject",
                    { projectId }
                );

                const dept =
                    res?.data?.data?.[0]?.departments || [];

                const formattedDept = dept.map((d) => ({
                    label: d.departmentName,
                    value: d.departmentId
                }));

                setDepartmentOptions(formattedDept);

            } catch (error) {
                console.log("Project Fetch Error", error);
                setDepartmentOptions([]);
            }
        };

        fetchProjectById();

    }, [projectId]);


    return { projectOptions, departmentOptions };
};